import React, { useState, useEffect } from "react";
import { FiFileText } from "react-icons/fi";
import API_URL from "../config";
import axios from "axios";
import "../styles/RenewalAlerts.css";
import { TiDeleteOutline } from "react-icons/ti";
import { useAdmin } from "../contexts/AdminContext";

const TermsAndCondition = () => {
  const { admin } = useAdmin();
  const [points, setPoints] = useState([""]);
  const [terms, setTerms] = useState([]);

  const [terminationPoints, setTerminationPoints] = useState([""]);
  const [terminationConditions, setTerminationConditions] = useState([]);
  const [warningMessage, setWarningMessage] = useState("");

  useEffect(() => {
    fetchTerms();
    fetchTerminationConditions();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API_URL}/terms/${admin?.branch}`);
      if (response.data && response.data.content) {
        setTerms(response.data.content);
        setPoints(response.data.content);
      }
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
    }
  };

  const fetchTerminationConditions = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/termination/${admin?.branch}`
      );
      if (response.data) {
        setTerminationConditions(response.data.conditions || []);
        setTerminationPoints(response.data.conditions || [""]);
        setWarningMessage(response.data.warningMessage || "");
      }
    } catch (error) {
      console.error("Error fetching termination conditions:", error);
    }
  };

  const handlePointChange = (index, value) => {
    const updatedPoints = [...points];
    updatedPoints[index] = value;
    setPoints(updatedPoints);
  };

  const addPoint = () => {
    setPoints([...points, ""]);
  };

  const removePoint = (index) => {
    const updatedPoints = points.filter((_, i) => i !== index);
    setPoints(updatedPoints);
  };

  const submitTerms = async () => {
    try {
      const response = await axios.post(`${API_URL}/terms`, {
        content: points.filter((point) => point.trim() !== ""),
        branch: admin?.branch,
      });
      alert(response.data.message);
      fetchTerms();
    } catch (error) {
      console.error("Error submitting terms and conditions:", error);
      alert("Failed to update terms and conditions.");
    }
  };

  const handleTerminationPointChange = (index, value) => {
    const updatedPoints = [...terminationPoints];
    updatedPoints[index] = value;
    setTerminationPoints(updatedPoints);
  };

  const addTerminationPoint = () => {
    setTerminationPoints([...terminationPoints, ""]);
  };

  const removeTerminationPoint = (index) => {
    const updatedPoints = terminationPoints.filter((_, i) => i !== index);
    setTerminationPoints(updatedPoints);
  };

  const submitTerminationConditions = async () => {
    try {
      const response = await axios.patch(`${API_URL}/termination`, {
        conditions: terminationPoints.filter((point) => point.trim() !== ""),
        warningMessage: warningMessage,
        branch: admin?.branch,
      });
      alert("Updated termination conditions!");
      fetchTerminationConditions();
    } catch (error) {
      console.error("Error submitting termination conditions:", error);
      alert("Failed to update termination conditions.");
    }
  };

  return (
    <div className="addUserManagementContainer">
      <div className="addUserManagementHeader">
        <div className="addUserHeaderLeft">
          <FiFileText size={30} color="#ff0000" style={{ marginRight: 10 }} />
          <h2>Terms And Conditions</h2>
        </div>
      </div>

      <div>
        <h2 style={{ marginBottom: 20 }}>Add/Update Terms</h2>
        {points.map((point, index) => (
          <div
            key={index}
            style={{
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={point}
              onChange={(e) => handlePointChange(index, e.target.value)}
              placeholder={`Point ${index + 1}`}
              style={{ width: "800px", padding: "10px" }}
            />
            <button
              onClick={() => removePoint(index)}
              style={{
                marginLeft: "10px",
                backgroundColor: "transparent",
                color: "#ff0000",
                border: "none",
                outline: "none",
                cursor: "pointer",
              }}
            >
              <TiDeleteOutline size={28} />
            </button>
          </div>
        ))}
        <div className="buttonFlex">
          <div className="gstSettingBtnContainer" style={{ marginLeft: 0 }}>
            <button style={{ padding: 8 }} onClick={addPoint}>
              Add Point
            </button>
          </div>
          <div className="gstSettingBtnContainer" style={{ marginLeft: 0 }}>
            <button onClick={submitTerms} style={{ padding: 8 }}>
              Submit Terms
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "50px" }}>
        <h2 style={{ marginBottom: 20 }}>Add/Update Termination Conditions</h2>
        <input
          type="text"
          value={warningMessage}
          onChange={(e) => setWarningMessage(e.target.value)}
          placeholder="Warning Message"
          style={{ width: "800px", padding: "10px", marginBottom: "20px" }}
        />
        {terminationPoints.map((point, index) => (
          <div
            key={index}
            style={{
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={point}
              onChange={(e) =>
                handleTerminationPointChange(index, e.target.value)
              }
              placeholder={`Condition ${index + 1}`}
              style={{ width: "800px", padding: "10px" }}
            />
            <button
              onClick={() => removeTerminationPoint(index)}
              style={{
                marginLeft: "10px",
                backgroundColor: "transparent",
                color: "#ff0000",
                border: "none",
                outline: "none",
                cursor: "pointer",
              }}
            >
              <TiDeleteOutline size={28} />
            </button>
          </div>
        ))}
        <div className="buttonFlex">
          <div className="gstSettingBtnContainer" style={{ marginLeft: 0 }}>
            <button style={{ padding: 8 }} onClick={addTerminationPoint}>
              Add Condition
            </button>
          </div>
          <div className="gstSettingBtnContainer" style={{ marginLeft: 0 }}>
            <button
              onClick={submitTerminationConditions}
              style={{ padding: 8 }}
            >
              Submit Termination Conditions
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "30px" }}>
        <h2>Current Terms and Conditions</h2>
        {terms.length > 0 ? (
          <ol>
            {terms.map((term, index) => (
              <li style={{ margin: "10px 0" }} key={index}>
                {term}
              </li>
            ))}
          </ol>
        ) : (
          <p>No terms and conditions available.</p>
        )}
      </div>

      <div style={{ marginTop: "30px" }}>
        <h2>Current Termination Conditions</h2>
        {terminationConditions.length > 0 ? (
          <ol>
            {terminationConditions.map((condition, index) => (
              <li style={{ margin: "10px 0" }} key={index}>
                {condition}
              </li>
            ))}
          </ol>
        ) : (
          <p>No termination conditions available.</p>
        )}
        {warningMessage && (
          <div>
            <h3 style={{ color: "#ff0000" }}>{warningMessage}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsAndCondition;
